// El brillo que barre la imagen mientras se edita en el visor —
// ADR-2026-10-06-brillo-mientras-se-edita.
//
// Una capa fija calzada sobre la `<img>` (por `imgRef`, como `LupaDeImagen`), recortada a
// sus bordes redondeados, con la franja de luz de `.brillo-de-edicion` (index.css). Se
// recalza al cambiar el tamaño de la ventana. Entra y sale con un fundido.

import { useEffect, useLayoutEffect, useRef, useState, type RefObject } from 'react';

export function BrilloSobreImagen({ imgRef, activo }: { imgRef: RefObject<HTMLImageElement>; activo: boolean }) {
  const capaRef = useRef<HTMLDivElement | null>(null);
  // Montado un rato más al apagarse, para que el fundido de salida se vea.
  const [montado, setMontado] = useState(activo);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (activo) {
      setMontado(true);
      const raf = window.requestAnimationFrame(() => setVisible(true));
      return () => window.cancelAnimationFrame(raf);
    }
    setVisible(false);
    const t = window.setTimeout(() => setMontado(false), 300);
    return () => window.clearTimeout(t);
  }, [activo]);

  useLayoutEffect(() => {
    if (!montado) return;
    const calzar = () => {
      const img = imgRef.current;
      const capa = capaRef.current;
      if (!img || !capa) return;
      const r = img.getBoundingClientRect();
      Object.assign(capa.style, { left: `${r.left}px`, top: `${r.top}px`, width: `${r.width}px`, height: `${r.height}px` });
    };
    calzar();
    window.addEventListener('resize', calzar);
    return () => window.removeEventListener('resize', calzar);
  }, [montado, imgRef]);

  if (!montado) return null;
  return (
    <div
      ref={capaRef}
      aria-hidden="true"
      className="pointer-events-none fixed z-[15] overflow-hidden rounded-lg transition-opacity duration-300 ease-out"
      style={{ opacity: visible ? 1 : 0 }}
    >
      <div className="brillo-de-edicion" />
    </div>
  );
}

export default BrilloSobreImagen;
